// src/index.jsx
import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter, RouterProvider } from 'react-router-dom';
import App from './App';
import router from './routes';

const root = ReactDOM.createRoot(document.getElementById('root'));
// root.render(
//   <BrowserRouter future={{
//     v7_startTransition: true,
//     v7_relativeSplatPath: true
//   }} >
//     <App />
//   </BrowserRouter>
// );
root.render(<RouterProvider router={router} future={{
    v7_startTransition: true,
    v7_relativeSplatPath: true
  }} />);
